import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { environment } from 'environment-configurations';
import * as i2 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i3 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';

class BulkDocumentsDownloadService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getFileBlob(path) {
        return this.httpClient.get(path, { responseType: "arraybuffer" }).pipe(map((response) => {
            return response;
        }));
    }
}
BulkDocumentsDownloadService.ɵfac = function BulkDocumentsDownloadService_Factory(t) { return new (t || BulkDocumentsDownloadService)(i0.ɵɵinject(i1.HttpClient)); };
BulkDocumentsDownloadService.ɵprov = i0.ɵɵdefineInjectable({ token: BulkDocumentsDownloadService, factory: BulkDocumentsDownloadService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BulkDocumentsDownloadService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BulkDocumentsDownloadComponent {
    constructor(apiService) {
        this.apiService = apiService;
        this.selectedFiles = [];
        this.fileName = 'Documents.zip';
    }
    ngOnInit() {
    }
    downloadZip() {
        let count = 0;
        const zip = new JSZip();
        this.selectedFiles = this.selectedFiles.map(file => {
            if (!file['path']) {
                file['path'] = file.fileLocation;
                file.fileLocation = environment.docs + file.fileLocation.substring(23);
            }
            return file;
        });
        this.selectedFiles.forEach((file, i) => {
            this.apiService.getFileBlob(file.fileLocation)
                .subscribe((response) => {
                const fileHasExtsn = file.fileName.split(".");
                const extsnFrompath = file['path'].split(".");
                const finalFileName = (i + 1) + '_' + ((fileHasExtsn.length > 1) ? file.fileName : (file.fileName + '.' + extsnFrompath[1]));
                zip.file(finalFileName, response, { base64: true });
                count++;
                if (count === this.selectedFiles.length) { // I have added this condition
                    zip.generateAsync({ type: "blob" })
                        .then((content) => {
                        // see FileSaver.js
                        saveAs(content, this.fileName);
                    });
                }
            });
        });
    }
}
BulkDocumentsDownloadComponent.ɵfac = function BulkDocumentsDownloadComponent_Factory(t) { return new (t || BulkDocumentsDownloadComponent)(i0.ɵɵdirectiveInject(BulkDocumentsDownloadService)); };
BulkDocumentsDownloadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: BulkDocumentsDownloadComponent, selectors: [["lib-bulk-documents-download"]], inputs: { selectedFiles: "selectedFiles", fileName: "fileName" }, decls: 1, vars: 1, consts: [["pButton", "", "type", "button", "icon", "pi pi-download", "iconPos", "left", "pTooltip", "Download Selected Documents as Zip File", 1, "p-button-outlined", "ml-2", 3, "disabled", "click"]], template: function BulkDocumentsDownloadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "button", 0);
        i0.ɵɵlistener("click", function BulkDocumentsDownloadComponent_Template_button_click_0_listener() { return ctx.downloadZip(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", !ctx.selectedFiles.length);
    } }, directives: [i2.ButtonDirective, i3.Tooltip], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BulkDocumentsDownloadComponent, [{
        type: Component,
        args: [{
                selector: 'lib-bulk-documents-download',
                template: `<button pButton class="p-button-outlined ml-2" type="button" icon="pi pi-download" iconPos="left" (click)='downloadZip()' [disabled]="!selectedFiles.length" pTooltip="Download Selected Documents as Zip File"></button>`,
                styles: []
            }]
    }], function () { return [{ type: BulkDocumentsDownloadService }]; }, { selectedFiles: [{
            type: Input
        }], fileName: [{
            type: Input
        }] }); })();

class BulkDocumentsDownloadModule {
}
BulkDocumentsDownloadModule.ɵfac = function BulkDocumentsDownloadModule_Factory(t) { return new (t || BulkDocumentsDownloadModule)(); };
BulkDocumentsDownloadModule.ɵmod = i0.ɵɵdefineNgModule({ type: BulkDocumentsDownloadModule });
BulkDocumentsDownloadModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[ButtonModule, TooltipModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BulkDocumentsDownloadModule, { declarations: [BulkDocumentsDownloadComponent], imports: [ButtonModule, TooltipModule], exports: [BulkDocumentsDownloadComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BulkDocumentsDownloadModule, [{
        type: NgModule,
        args: [{
                declarations: [BulkDocumentsDownloadComponent],
                imports: [ButtonModule, TooltipModule],
                exports: [BulkDocumentsDownloadComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of bulk-documents-download
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BulkDocumentsDownloadComponent, BulkDocumentsDownloadModule, BulkDocumentsDownloadService };
//# sourceMappingURL=bulk-documents-download.js.map
